module.exports = __webpack_public_path__ + "img/D1.5684849c.jpg";